import type { Ware } from '@models/ware'
import type { AxiosError } from 'axios'
import ms from 'ms'
import { useQuery } from 'react-query'
import waresApi from './actions'
import { waresKeys } from './constants'

export interface UseWaresProps {
  wares: Ware[]
  waresMap: Map<number, Ware>
}

export const selectData = (data: Ware[]): UseWaresProps => {
  return {
    wares: data,
    waresMap: new Map(data.map(ware => [ware.id, ware])),
  }
}

const useWares = (orderId?: number) => {
  const query = useQuery<Ware[], AxiosError, UseWaresProps>(
    waresKeys.root(orderId!),
    () => waresApi.getWares(orderId!),
    {
      select: selectData,
      enabled: !!orderId,
      staleTime: ms('10m'),
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
    },
  )

  return query
}

export default useWares
